function Budget({ allocatedBudget, currentSpend, type }) {
  return (
    <>
      {type === "Goal" ? (
        <p className='inventory-item'>
          Allocated budget: ${allocatedBudget? allocatedBudget.toLocaleString() : ""}
        </p>
      ) : (
        ""
      )}
      <p className='inventory-item'>
        Current spend: ${currentSpend? currentSpend.toLocaleString() : ""}
      </p>
    </>
  );
}

export default Budget;
